@for (button of email.actionButtons; track button) {
  @switch (button) {
    @case (EmailActionsEnum.Validate) {
      <app-validate-button
        [isMenu]="isMenu"
        [disabled]="!!email?.isLoadingValidate"
        [showButton]="
          (email.validationState === EmailValidationState.NotValidated ||
            email.validationState === EmailValidationState.New) &&
          !email?.isLoadingValidate
        "
        [showLoading]="!!email?.isLoadingValidate"
        (click)="actions.setValidated(email.emailId)" />
    }

    @case (EmailActionsEnum.DeleteFinalMail) {
      <app-final-delete-button
        [isMenu]="isMenu"
        (click)="actionsModals.finalDelete(email.emailId)" />
    }

    @case (EmailActionsEnum.Reply) {
      <app-reply-button
        [isMenu]="isMenu"
        [showButton]="
          emailsPageStateService.replyingEmailId() !== email.emailId ||
          emailsPageStateService.loadingActionFromHeader()
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          emailsPageStateService.replyingEmailId() === email.emailId &&
          !emailsPageStateService.loadingActionFromHeader()
        "
        (click)="buttonActionsService.reply(email)" />
    }

    @case (EmailActionsEnum.ReplyAll) {
      <app-reply-all-button
        [isMenu]="isMenu"
        [showButton]="
          emailsPageStateService.replyingAllEmailId() !== email.emailId ||
          emailsPageStateService.loadingActionFromHeader()
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          emailsPageStateService.replyingAllEmailId() === email.emailId &&
          !emailsPageStateService.loadingActionFromHeader()
        "
        (click)="buttonActionsService.replyAll(email)" />
    }

    @case (EmailActionsEnum.Forward) {
      <app-forward-button
        [isMenu]="isMenu"
        [showButton]="
          emailsPageStateService.forwardingAsTextEmailId() !== email.emailId ||
          emailsPageStateService.loadingActionFromHeader()
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          emailsPageStateService.forwardingAsTextEmailId() === email.emailId &&
          !emailsPageStateService.loadingActionFromHeader()
        "
        (click)="buttonActionsService.forward(email.emailId)" />
      <app-forward-attachment-button
        [isMenu]="isMenu"
        [showButton]="
          emailsPageStateService.forwardingAsAttachmentEmailId() !==
            email.emailId || emailsPageStateService.loadingActionFromHeader()
        "
        [disabled]="emailsPageStateService.isAnyActionInProgress()"
        [showLoading]="
          emailsPageStateService.forwardingAsAttachmentEmailId() ===
            email.emailId && !emailsPageStateService.loadingActionFromHeader()
        "
        (click)="buttonActionsService.forwardAsAttachment(email.emailId)" />
    }

    @case (EmailActionsEnum.Reassign) {
      <app-reassign-button
        [isMenu]="isMenu"
        (click)="actionsModals.reassign(email.emailId)" />
    }

    @case (EmailActionsEnum.Groups) {
      <app-groups-button
        [isMenu]="isMenu"
        (click)="actionsModals.openAddGroupDialog(email)" />
    }

    @case (EmailActionsEnum.Tags) {
      <app-tags-button
        [isMenu]="isMenu"
        (click)="actionsModals.openAddTagDialog(email)" />
    }

    @case (EmailActionsEnum.SetRead) {
      @if (!email.seen) {
        <app-set-read-button
          [isMenu]="isMenu"
          (click)="actions.setSeen(true, email)" />
      }
    }

    @case (EmailActionsEnum.SetUnread) {
      @if (email.seen) {
        <app-set-unread-button
          [isMenu]="isMenu"
          (click)="actions.setSeen(false, email)" />
      }
    }

    @case (EmailActionsEnum.MarkAsSpam) {
      @if (!email.isSpam) {
        <app-mark-as-span-button
          [isMenu]="isMenu"
          (click)="actions.setSpam(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.Delete) {
      @if (!email.deleted) {
        <app-delete-button
          [isMenu]="isMenu"
          (click)="actionsModals.delete(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.DownloadSingleEml) {
      <app-download-single-eml-button
        [isMenu]="isMenu"
        [showButton]="!email?.isDownloadingSingleEML"
        [showLoading]="!!email?.isDownloadingSingleEML"
        (click)="actions.downloadSingleEML(email.emailId)" />
    }

    @case (EmailActionsEnum.DownloadEml) {
      <app-download-eml-button
        [isMenu]="isMenu"
        [showButton]="!email?.isDownloadingEML"
        [showLoading]="!!email?.isDownloadingEML"
        (click)="actions.downloadEML(email.emailId)" />
    }

    @case (EmailActionsEnum.Restore) {
      @if (email.deleted) {
        <app-restore-button
          [isMenu]="isMenu"
          (click)="actionsModals.restoreFromTrash(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.MarkAsNotSpam) {
      @if (email.isSpam) {
        <app-mark-as-not-span-button
          [isMenu]="isMenu"
          (click)="
            buttonActionsService.restoreMoveFolderChoose(
              [email.emailId],
              'restoreOneSpam'
            )
          " />
      }
    }

    @case (EmailActionsEnum.Archiving) {
      <app-archiving-button
        [isMenu]="isMenu"
        (click)="actionsModals.archiving(email.emailId)" />
    }

    @case (EmailActionsEnum.MoveToFolder) {
      @if (isMenu) {
        <app-move-to-folder-button
          [isMenu]="true"
          (click)="actionsModals.move(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.Archive) {
      @if (isMenu) {
        <app-archive-button
          [isMenu]="true"
          (click)="actionsModals.setSelectedArchive(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.Audit) {
      @if (isMenu) {
        <app-audit-button
          [isMenu]="true"
          (click)="actionsModals.openAudit(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.RetrySending) {
      @if (isMenu) {
        @if (email.state === EmailState.SendError) {
          <app-retry-sending-button
            [isMenu]="true"
            (click)="actions.retrySend(email.emailId)" />
        }
      }
    }

    @case (EmailActionsEnum.MoveToDraft) {
      @if (isMenu) {
        @if (
          email.state === EmailState.VirusDetected ||
          email.state === EmailState.SendError
        ) {
          <app-move-to-draft-button
            [isMenu]="true"
            (click)="actions.moveToDraft(email.emailId)" />
        }
      }
    }

    @case (EmailActionsEnum.RestoreArchive) {
      @if (isMenu) {
        <app-restore-archive-button
          [isMenu]="true"
          (click)="actionsModals.restoreFromArchive(email.emailId)" />
      }
    }

    @case (EmailActionsEnum.Meta) {
      @if (isMenu) {
        <app-meta-button
          [isMenu]="true"
          (click)="actionsModals.openMeta(email.emailId)" />
      }
    }
  }
}
